<template lang='pug'>
  el-menu.el-menu-vertical-admin(default-active='2', @open='handleOpen',
    @close='handleClose',active-text-color='#ffd04b')
    el-menu-item(index='1-1', @click='addUser')
      i.el-icon-circle-plus
      span Προσθήκη Εσωτερικού Χρήστη
    el-menu-item(index='1-2', @click='addForeignUser')
      i.el-icon-circle-plus
      span Προσθήκη Αλλοδαπού Χρήστη
    el-menu-item(index='1-3', @click='addUniversity')
      i.el-icon-circle-plus
      span Διαχειριστικό Ιδρυμάτων
    el-menu-item.block(index='1-4')
      el-cascader(placeholder='Εύρεση Χρήστη', :options='usersNameLabels', filterable='',
      change-on-select, size='large', v-loading="loadingInternalUsers", expand-trigger='click',
      @change='modifyUser')
    <!--el-submenu(index='1', v-model='internalUsers' v-loading="loadingInternalUsers")-->
      <!--template(slot='title')-->
        <!--i.el-icon-location-->
        <!--span Χρήστες-->
      <!--el-menu-item.admin-menu-item(v-for='employ in this.internalUsers',  @click='modifyUser(employ.id)',-->
      <!--:key='employ.id', :index='userIndexId (employ.id)') {{employ.name}} {{employ.surname}}-->
    el-submenu(index='2', @click='handleOpen', v-loading="loadingInternalRoles")
      template(slot='title')
        i.el-icon-menu
        span Ρόλοι
      el-menu-item.admin-menu-item(v-for='role in roles',
        :key='role.id', @click='modifyRole (role.id)', :index='roleIndexId (role.id)'
        style="padding-left: 10px;") {{role.gr_name}}
    el-menu-item(index='1000', @click='toggleSearch')
      template(slot='title')
        i.el-icon-search
        span Αναζήτηση Αιτήσεων
    el-menu-item(index='1003', @click='toggleUniSearch')
      template(slot='title')
        i.el-icon-search
        span Αναζήτηση Ιδρυμάτων
    el-menu-item(index='1001', @click='toggleForeignSearch')
      template(slot='title')
        i.el-icon-search
        span Αναζήτηση Αλλοδαπών Χρηστών
    el-menu-item(index='1002', @click='toggleStats')
      template(slot='title')
        i.el-icon-search
        span Στατιστικά Αιτήσεων
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    usersNameLabels () {
      return this.internalUsers.map(function (user) {
        return {
          value: user.id,
          label: user.name + ' ' + user.surname
          // children: user.doatap_roles.map(function (role) {
          //   return {
          //     value: role.id,
          //     label: role.name
          //   }
          // })
        }
      })
    },
    ...mapGetters({
      loadingInternalUsers: 'loadingInternalUsers',
      loadingInternalRoles: 'loadingInternalRoles',
      roles: 'roles',
      internalUsers: 'internalUsers'
    })
  },
  methods: {
    toggleSearch () {
      // this.searchVisible = !this.searchVisible
      this.$store.dispatch('SHOW_HIDE_APPSEARCH')
    },
    toggleUniSearch () {
      this.$store.dispatch('SHOW_HIDE_UNISEARCH')
    },
    toggleForeignSearch () {
      this.$store.dispatch('SHOW_HIDE_FOREIGN_USER_SEARCH')
    },
    toggleStats () {
      this.$store.dispatch('SHOW_HIDE_STATS')
    },
    addUser () {
      this.$emit('addUser')
    },
    addUniversity () {
      this.$emit('addUniversity')
    },
    addForeignUser () {
      this.$emit('addForeignUser')
    },
    modifyUser (id) {
      this.$emit('modifyUser', id)
      // this.$store.dispatch('LOAD_INTERNAL_USERS')
    },
    modifyRole (id) {
      this.$emit('modifyRole', id)
      // this.$store.dispatch('LOAD_INTERNAL_USERS')
    },
    userIndexId (userId) {
      return `1-${userId + 1}`
    },
    roleIndexId (roleId) {
      return `2-${roleId + 1}`
    },
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    }
  }
}
</script>

<style lang='scss' scoped>
// li.el-menu-item {
//   padding-left: 10px;
// }
.is-active {
  color: blue;
}
// li.el-menu-item.admin-menu-item {
//   padding-left: 5px;
// }
.el-submenu {
  border-radius: 20px;
  overflow-wrap: break-word;
  border: 2px solid #7fa3bb;
  padding: 5px;
  &__title:hover {
    background-color: "#b3c0d1";
  }
}
.el-menu-vertical-admin {
  margin: 5px;
  word-wrap: break-word;
  border-radius: 0px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
}
/*.el-menu-item {*/
  /*border-radius: 15px 30px;*/
  /*border: 2px solid #7fa3bb;*/
  /*padding: 5px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/AdminMenu.vue